import { createActions, handleActions } from 'redux-actions';

const initialState = {
  notification: {
    isVisible: false,
    type: null,
  },
};

const SET_NOTIFICATION = 'DESIGN_PRO/NOTIFICATION/SET_NOTIFICATION';
const HANDLE_NOTIFICATION = 'DESIGN_PRO/NOTIFICATION/HANDLE_NOTIFICATION';

const actions = createActions({
  [SET_NOTIFICATION]: (notification) => ({ notification }),
  [HANDLE_NOTIFICATION]: (notificationType) => notificationType,
});

const reducer = handleActions(
  {
    [actions.designPro.notification.setNotification]: (state, action) => ({
      ...state,
      notification: action.payload.notification,
    }),
  },
  initialState,
);

export default {
  initialState,
  actions: actions.designPro.notification,
  reducer,
};
